import { finalFilterStringFunction } from 'lib/reusable-components/reusableFunction/chartHealperReusableFunction';
import {
  defaultChartName,
  defaultNestedArrayDraggableID,
  defaultReportChartData,
  defaultReportInsightData,
  defaultReportType,
} from '../data/defaultSchema';
import { extractIndexFromDraggableID, updateChartSchemaInServer } from './helperFunction';
export const changeDestinationFunction = async (props: changeDestinationProps) => {
  const { sourceData, setDestinationData, result, chartsData, stateProps } = props;
  const { source, destination } = result;
  const {
    handleTableData,
    appID,
    analyticsSchema,
    tableDataInSheetID,
    setTableDataInSheetID,
    reportFilter,
    reportTimeFrame,
  } = stateProps;

  const sourcetargetIndex = extractIndexFromDraggableID(
    source.droppableId,
    defaultNestedArrayDraggableID.first
  );

  if (source.index === null || destination.index === null) {
    console.log('Index is null');
    return;
  }
  // Tools
  if (sourcetargetIndex === null) {
    const targetedSource: any = sourceData[source.index];
    setDestinationData((currentDestinationData: any) => {
      const duplicateDestinationArray: any[] = Array.from(currentDestinationData);

      // update Targeted ChartsArray
      duplicateDestinationArray.splice(destination.index, 0, targetedSource);

      return duplicateDestinationArray;
    });
    return;
  }

  // Charts
  const targetedSource: any =
    sourceData[Object.keys(sourceData)?.[sourcetargetIndex]]?.charts?.[source.index];
  if (!targetedSource) {
    console.log('target Id Chart not found');
    return;
  }
  const plotDataWithTableProps = {
    type: defaultReportChartData.type,
    chartID: targetedSource,
    appID,
    analyticsSchema,
    chartsData,
    setTableDataInSheetID,
    tableDataInSheetID,
    handleTableData,
    reportTimeFrame,
    reportFilter,
  };

  const plotDataRes = await getPlotDataWithTable(plotDataWithTableProps);
  if (plotDataRes.skip) {
    return;
  }

  const filterString = finalFilterStringFunction({
    filtersSchema: chartsData[targetedSource].filters,
    chartName: chartsData[targetedSource].name,
  });

  const chartItem = {
    ...defaultReportChartData,
    chartID: targetedSource,
    sheetID: chartsData[targetedSource]?.sheetID || '',
    style: {
      ...defaultReportChartData.style,
      chartWidth: chartsData[targetedSource]?.chartWidth || 'ONEFOURTH',
    },
    chartFilter: chartsData[targetedSource].filters,
    filterMsg: filterString,
    plotData: plotDataRes.plotData,
  };

  const chartName = {
    ...defaultChartName,
    input: chartsData[targetedSource]?.name,
  };

  setDestinationData((currentDestinationData: any) => {
    const duplicateDestinationArray: any[] = Array.from(currentDestinationData);
    // update Targeted ChartsArray
    duplicateDestinationArray.splice(destination.index, 0, chartItem);
    duplicateDestinationArray.splice(destination.index, 0, chartName);
    return duplicateDestinationArray;
  });
};

export const sameDestinationFunction = (props: sameDestinationProps) => {
  const { setSourceData, result } = props;

  const { source, destination } = result;
  setSourceData((currentData: any[]) => {
    const items = Array.from(currentData);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);
    return items;
  });
};
interface changeDestinationProps {
  sourceData: any;
  setSourceData: Function;
  destinationData: any;
  setDestinationData: Function;
  result: any;
  chartsData: any;
  stateProps: any;
}
interface sameDestinationProps {
  setSourceData: Function;
  result: any;
}
interface getPlotDataProps {
  tableSchema: any;
  reportTimeFrame: any;
  chartSchema: any;
  type: string;
  filters: any;
}
export const getPlotData = async ({
  tableSchema,
  reportTimeFrame,
  chartSchema,
  type,
  filters,
}: getPlotDataProps) => {
  let timeFrame = {};
  const isInsights = type === defaultReportInsightData.type;
  if (tableSchema?.defaultTable?.defaultDatetimeCol) {
    const datetimeColumn = tableSchema?.data.find(
      (elem: any) =>
        `${elem?.tableName}.${elem?.columnName}` === tableSchema?.defaultTable?.defaultDatetimeCol
    );
    if (datetimeColumn) {
      timeFrame = {
        [tableSchema.defaultTable.defaultDatetimeCol]: {
          column: datetimeColumn.columnName,
          dataType: datetimeColumn.dataType,
          tableName: datetimeColumn.tableName,
          name: datetimeColumn.name,
          sheetID: datetimeColumn.sheetID,
          value: reportTimeFrame,
        },
      };
    }
  }

  const schemaData = await updateChartSchemaInServer({
    chartSchemaMemo: { ...chartSchema, timeFrame: timeFrame },
    endPoint: isInsights ? 'insights' : 'createCharts',
    isInsights: isInsights,
    filters: filters,
  });

  if (schemaData.skip) {
    return { skip: true, msg: 'PlotData not found' };
  }
  return { skip: false, plotData: schemaData.plotData };
};

interface getPlotDataWithTablePorps {
  type: string;
  chartID: string;
  appID: string;
  analyticsSchema: any;
  chartsData: any;
  setTableDataInSheetID: Function;
  handleTableData: Function;
  tableDataInSheetID: any;
  reportTimeFrame: any;
  reportFilter: any;
}
export const getPlotDataWithTable = async ({
  chartID,
  type,
  analyticsSchema,
  chartsData,
  setTableDataInSheetID,
  appID,
  tableDataInSheetID,
  handleTableData,
  reportTimeFrame,
  reportFilter,
}: getPlotDataWithTablePorps) => {
  const handleTableProps = {
    selectedTable:
      analyticsSchema?.appSheets[chartsData[chartID]?.sheetID ?? '']?.defaultTable?.tableID,
    appID: appID,
    sheetID: chartsData[chartID]?.sheetID ?? '',
    tableDataInSheetID: tableDataInSheetID,
    setTableDataInSheetID: setTableDataInSheetID,
  };
  const tableData = await handleTableData(handleTableProps);
  const plotDataProps = {
    tableSchema:
      tableData?.tableDataInSheetID?.[
        chartsData[chartID]?.sheetID as keyof typeof tableDataInSheetID
      ],
    reportTimeFrame,
    type: type,
    chartSchema: chartsData[chartID],
    filters: reportFilter,
  };

  const plotDataRes = await getPlotData(plotDataProps);
  if (plotDataRes.skip) {
    return { skip: true, msg: plotDataRes.msg };
  }
  return { skip: false, plotData: plotDataRes.plotData };
};
interface updateReportPlotAreaPorps {
  appID: string;
  reports: any[];
  analyticsSchema: any;
  chartsData: any;
  setTableDataInSheetID: any;
  handleTableData: Function;
  tableDataInSheetID: any;
  reportTimeFrame: any;
  reportFilter: any;
}
export const updateReportPlotArea = async ({
  reports,
  analyticsSchema,
  chartsData,
  setTableDataInSheetID,
  tableDataInSheetID,
  handleTableData,
  reportTimeFrame,
  reportFilter,
  appID,
}: updateReportPlotAreaPorps) => {
  let finalReport: any[] = [];

  for (let index = 0; index < reports.length; index++) {
    const currentReport: { [key: string]: any } = reports[index];
    if (
      currentReport.type === defaultReportType.insights ||
      currentReport.type === defaultReportType.charts
    ) {
      const plotDataWithTableProps = {
        type: currentReport.type,
        chartID: currentReport.chartID,
        appID,
        analyticsSchema,
        chartsData,
        setTableDataInSheetID,
        tableDataInSheetID,
        handleTableData,
        reportTimeFrame,
        reportFilter,
      };
      const plotDataWithTable = await getPlotDataWithTable(plotDataWithTableProps);
      if (plotDataWithTable.skip) {
      } else {
        finalReport = [...finalReport, { ...currentReport, plotData: plotDataWithTable.plotData }];
      }
    } else {
      finalReport = [...finalReport, currentReport];
    }
  }
  return { skip: false, reports: finalReport };
};
